import { Input, InputGroup, InputLeftElement, Icon } from '@chakra-ui/react';
import { CiCalendar } from 'react-icons/ci';
import { ForwardedRef, forwardRef } from 'react';

interface IUIDateInput {
  value?: string;
  onClick?: () => void;
  onChange?: () => void;
  placeholder?: string;
}

export const UIDateInput = forwardRef((props: IUIDateInput, ref: ForwardedRef<HTMLInputElement>) => {
  const { value, onClick, onChange, placeholder, ...restInputProps } = props;

  return (
    <InputGroup size='lg' onClick={onClick}>
      <InputLeftElement children={<Icon as={CiCalendar} />} />
      <Input
        onChange={onChange}
        value={value}
        placeholder={placeholder || 'dd / mm / yyyy'}
        ref={ref}
        {...restInputProps}
      />
    </InputGroup>
  );
});
